module["exports"] = [
  "#####",
  "####",
  "###",
  "##",
  "#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/address/building_number.js
// module id = 1821
// module chunks = 0